import React from 'react';
import GridItem from '../../../../layout/GridComponents/GridItem';
import CustomTable from '../../../../tables/CustomTable';
import { CustomColumn } from '../../../../../types/components/tables/tableTypes';
import { percentageToNdecialPlaces } from '../../../../../utilities/numberFormatters';
import type { RelativeRiskPayload } from '../../../../../api/rs-hg/risk/relativeRisk.types';

interface RelativeRiskTableProps {
  data: RelativeRiskPayload;
}

interface RelativeRiskTableData {
  index: string;
  indexVaR: number;
  fundVaR: string;
  relativeRisk: number;
}

const columns: CustomColumn<RelativeRiskTableData>[] = [
  {
    title: 'Index',
    field: 'index',
    cellStyle: {
      textAlign: 'center',
    },
    headerStyle: {
      textAlign: 'center',
    },
  },
  {
    title: `Index VaR`,
    field: 'indexVaR',
    cellStyle: {
      textAlign: 'center',
    },
    headerStyle: {
      textAlign: 'center',
    },
    render(rowData: RelativeRiskTableData) {
      return percentageToNdecialPlaces(rowData.indexVaR, 2);
    },
  },
  {
    title: `Fund VaR`,
    field: 'fundVaR',
    cellStyle: {
      textAlign: 'center',
    },
    headerStyle: {
      textAlign: 'center',
    },
    render(rowData: RelativeRiskTableData) {
      return percentageToNdecialPlaces(rowData.fundVaR, 2);
    },
  },
  {
    title: `Relative Risk`,
    field: 'relativeRisk',
    cellStyle: {
      textAlign: 'center',
    },
    headerStyle: {
      textAlign: 'center',
    },
  },
];

const buildTableData = (
  inputData: RelativeRiskPayload,
): RelativeRiskTableData[] => {
  if (!inputData.index_data?.length) {
    return [];
  }

  return inputData.index_data.map((index) => ({
    index: index.index,
    indexVaR: index.index_var,
    fundVaR: index.fund_var,
    relativeRisk: index.relative_risk,
  }));
};

const RelativeRiskTable: React.FC<RelativeRiskTableProps> = ({ data }) => {
  const builtTableData = buildTableData(data);

  return (
    <GridItem xs={12} card>
      <CustomTable<RelativeRiskTableData>
        columns={columns}
        showToolbar
        data={builtTableData}
        title={`Relative Value At Risk Breakdown`}
        options={{
          paging: false,
          search: true,
          exportButton: true,
          draggable: false,
        }}
      />
    </GridItem>
  );
};

export default RelativeRiskTable;
